export default 1280;

export const availableSections = [
  'report',
  'lineup',
  'table',
  'events',
  'scorecard',
  'photos',
  'overview',
];

/**
 * These events will be populated into the Key Moments section of the match centre.
 *
 * @type {string[]}
 */
export const keyEventTypes = [
  'goal',
  'try',
  'penalty',
  'scored penalty',
  'missed penalty',
  'red card',
  'own goal',
];

/**
 * These events will display a scoreline on the event card to the right-hand side of the scorecard.
 *
 * @type {string[]}
 */
export const matchCommentaryScoreLineEvents = ['Goal', 'Penalty', 'Try', 'Conversion', 'Own Goal'];

export const oppositionEvent = 'opposition_event';
export const homeEvent = 'event';
export const ownGoal = 'own goal';
